import React from 'react';
import { Route, Redirect } from 'react-router';
import Layout from './components/Layout';
import CalculationWrapper from './components/CalculationWrapper';
import CalculationResult from './components/CalculationResult';
import Projects from "./components/Projects";
import Login from "./components/Login";
import Logout from "./components/Logout";
import Admin from "./components/Admin";

export default () => (
    <Layout>
        <Route exact path='/'>
            <Redirect to="/calculation" />
        </Route>
        <Route path='/calculation' component={CalculationWrapper} />
        <Route path='/result' component={CalculationResult} />
        <Route path='/projects' component={Projects} />
        <Route path='/login' component={Login} />
        <Route path='/logout' component={Logout} />
        <Route path='/admin' component={Admin} />
    </Layout>
);



// WEBPACK FOOTER //
// ./src/App.js